import { render, staticRenderFns } from "./ProposalTable.vue?vue&type=template&id=a019e620&scoped=true"
import script from "./ProposalTable.vue?vue&type=script&lang=js"
export * from "./ProposalTable.vue?vue&type=script&lang=js"
import style0 from "./ProposalTable.vue?vue&type=style&index=0&id=a019e620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a019e620",
  null
  
)

export default component.exports